import ActiveLink from "@/components/ActiveLink";
import DropdownMenu from "@/components/DropdownMenu";
import { SearchForm, SearchFormSp } from "@/components/Form/index";
import LogoutModal from "@/components/LogoutModal";
import { useAuthUserQuery, useModal } from "@/hooks";
import { profileIconImages } from "@/lib/constants";
import routes from "@/lib/routes";
import dropDownStyles from "@/styles/DropdownMenu.module.scss";
import styles from "@/styles/Header.module.scss";
import Image from "next/legacy/image";
import Link from "next/link";
import { useRouter } from "next/router";
import { useCallback } from "react";
import IconArrow from "../../svgs/icon_arrow.svg";
import Notice from "./Notice";

function AuthorizedNavigation({ loggedIn }) {
  const { showModal } = useModal();
  const showLogoutModal = useCallback(() => {
    showModal(<LogoutModal />, { closeButton: false, style: "logout" });
  }, []);
  if (!loggedIn) return null;
  if (!loggedIn?.currentProfile) return null;
  const ownerProfile = loggedIn?.currentProfile?.ownerProfile;
  const iconId = loggedIn?.currentProfile?.icon || 1;
  return (
    <div className={`${styles.navElement} ${styles.user}`}>
      <ul className={styles.user}>
        <li>
          <DropdownMenu
            right
            button={
              <a className={styles.userMenuOpenBtn} role="button">
                <span className={styles.profileImage}>
                  {!!profileIconImages[iconId] && (
                    <Image
                      src={profileIconImages[iconId]}
                      width={28}
                      height={28}
                    />
                  )}
                </span>
                <span className={styles.profileName}>
                  {loggedIn.currentProfile.displayName}
                  <span className={styles.iconDropdown}>
                    <IconArrow />
                  </span>
                </span>
              </a>
            }
            scopedClass={dropDownStyles.forHeaderMenu}
          >
            <div
              className={`${dropDownStyles.innerSection} ${styles.dropDownProfileName}`}
            >
              <div>{loggedIn.currentProfile.displayName}</div>
            </div>
            <div className={dropDownStyles.innerSection}>
              <ul className={dropDownStyles.lists}>
                {ownerProfile && (
                  <li className={dropDownStyles.list}>
                    <Link href={routes.account} className={dropDownStyles.link}>
                      アカウント
                    </Link>
                  </li>
                )}

                <li className={dropDownStyles.list}>
                  <Link
                    href={routes.profileSwitch()}
                    className={dropDownStyles.link}
                  >
                    プロフィール切り替え
                  </Link>
                </li>
              </ul>
            </div>
            <div className={dropDownStyles.innerSection}>
              <ul className={dropDownStyles.lists}>
                <li className={dropDownStyles.list}>
                  <Link
                    href="/static/feature/constant/guide"
                    className={dropDownStyles.link}
                  >
                    ご利用ガイド
                  </Link>
                </li>
              </ul>
            </div>
            <div className={dropDownStyles.innerSection}>
              <ul className={dropDownStyles.lists}>
                <li className={dropDownStyles.list}>
                  <a className={dropDownStyles.link} onClick={showLogoutModal}>
                    ログアウト
                  </a>
                </li>
              </ul>
            </div>
          </DropdownMenu>
        </li>
      </ul>
    </div>
  );
}

function NotAuthorizedNavigation({ loggedIn }) {
  if (loggedIn) return null;
  return (
    <div className={`${styles.navElement} ${styles.anonymous}`}>
      <div className={styles.btnArea}>
        <ActiveLink
          className={styles.secondaryNavigationContLink}
          href={routes.login}
        >
          <span>ログイン</span>
        </ActiveLink>
        <ActiveLink
          className={styles.secondaryNavigationContLink}
          href={routes.login}
        >
          <span>会員登録</span>
        </ActiveLink>
      </div>
    </div>
  );
}

export default function SecondaryNavigation() {
  const router = useRouter();
  const { loading, data } = useAuthUserQuery({ fetchPolicy: "cache-first" });

  const loggedIn = !loading && data?.user;
  const handleSubmit = useCallback((data) => {
    router.push(routes.search(data.search));
  }, []);

  return (
    <div className={styles.secondaryNavigation}>
      <SearchForm onSubmit={handleSubmit} />
      <SearchFormSp onSubmit={handleSubmit} />
      <Notice />
      <NotAuthorizedNavigation loggedIn={loggedIn} />
      <AuthorizedNavigation loggedIn={loggedIn} />
    </div>
  );
}
